
  import { butter } from "~/plugins/buttercms";
  import debounce from '~/plugins/lodash';

  export default {
    name:'cal-city-section',
    props: {
      showProvince: {
        type: Boolean,
        default: true,
        required: false
      },
      fontVital: {
        type: Boolean,
        default: false,
        required: false
      },
      selectedCityAsProp: {
        type: Object,
        default: () => ({}),
        required: false
      }
    },
    data() {
      return {
        searchTown: {},
        selectedTown:{},
        isDropdownOpenDesktop: false,
        isDropdownOpenMobile: false,
        filteredTown: [],
        allTowns: {},
        towns: [],
        isShowCitySelector:false,
        showSlideOver: false,
        isShowSearchInput:false,
        defaultCityList:[],
        searchQuery: '',
        suggestions: [],
        isCityInputStyle:false,
        isDeliveryDate:''
      };
    },
    async created(){
      // TODO refactor the code
      let self = this;
      window.addEventListener('click', function(e){
        if (!self.$el.contains(e.target) && !(e.target.id === "add_to_basket_btn")){
          self.isShowCitySelector = false
        }
      });
      this.selectedTown=JSON.parse(sessionStorage.getItem("deliveryTown")) || {};
      this.isCityInputStyle=this.$route.fullPath.includes('collection');
      this.isDeliveryDate=sessionStorage.deliveryDate !== "";
      if(this.selectedTown && Object.keys(this.selectedTown).length > 0){
        this.$nuxt.$emit("cityUpdated", this.selectedTown);
      }
    },
    mounted(){
      this.$nuxt.$on("toggleCitySelector", (device) => {
        this.toggleIsShowCitySelector(device);
      });
    },
    watch: {
      selectedCityAsProp(newVal) {
        this.selectedTown = newVal;
      }
    },
    methods: {
     async onInput() {
        debounce(this.getSuggestions(), 200);
        this.isDropdownOpenDesktop = true;
      },
      async getSuggestions() {
        if (this.searchQuery.length > 0) {
          this.suggestions = await this.$store.dispatch('cartItem/FETCH_SUGGESTIONS', this.searchQuery.trim());
        } else {
          this.suggestions = [];
        }
      },
      toggleDropdown() {
        this.isDropdownOpenDesktop = !this.isDropdownOpenDesktop;
        this.isDropdownOpenMobile = !this.isDropdownOpenMobile;
      },
      toggleIsShowCitySelector(device) {
        // TODO refactor the code
        const ele = document.getElementById("date_selector");
        if (ele !== null) {
          return;
        }
        this.isShowCitySelector = !this.isShowCitySelector;
        this.showSlideOver = true;
        this.isShowSearchInput = true;
        this.isDropdownOpenMobile = true;
        if (device === 'mobile') {
          this.toggleBodyScrolling();
        }

        // set auto focus for city search input field
        if (this.isShowSearchInput) {
          this.$nextTick(() => {
            (this.$refs.citySearchDesktop) ? this.$refs.citySearchDesktop.focus() : '';
            (this.$refs.citySearchMobile) ? this.$refs.citySearchMobile.focus() : '';
          });
        }
      },
      closeSlideOver() {
        this.isShowCitySelector = false;
        this.showSlideOver = false;
        this.toggleBodyScrolling();
      },
      selectOptionMobile(suggestion) {
        this.sendToDataLayer();
        this.searchTown = suggestion;
        this.searchQuery = suggestion.name;
        this.save();
      },
      selectOptionDesktop(suggestion) {
        this.sendToDataLayer();
        this.searchTown = suggestion;
        this.searchQuery = suggestion.name;
        this.isDropdownOpenDesktop = false;
        this.save();
      },
      save() {
        this.isShowCitySelector = false;
        this.selectedTown = this.searchTown;
        this.$emit("select-city", this.selectedTown);
        this.$nuxt.$emit("cityUpdated", this.selectedTown);
        this.toggleBodyScrolling();
      },
      toggleBodyScrolling() {
        let body = document.body;
        body.style.overflow = (!this.isShowCitySelector) ? 'auto' : 'hidden';
      },
      sendToDataLayer() {
        window.dataLayer?.push({
          event: "city_selection",
          first_item: sessionStorage.cartItems === undefined,
          has_selected: this.selectedTown.name !== undefined
        });
      }
    },
    async fetch() {
      try {
        const page = await butter(this.$config).page.retrieve("collection_page", "collection",
          {
            locale: this.$i18n.locale,
          }
        );
        let pageData = page?.data.data.fields;
        let defaultCity = { name:'', province:'', regionName:'', regionShortCode:'', regionTag:''}
      //  TODO remove default cities
        pageData['default_delivering_cities'].forEach((city) => {
        defaultCity = { name: city.name, province: city.province, regionName: city.region_name, regionShortCode: city.region_short_code, regionTag: city.region_tag }
        this.defaultCityList.push(defaultCity);
      })
      } catch (error) {
        console.error(error);
      }
    },
  };
